export default class CartPage extends HTMLDivElement
{

    constructor() {
        super();
        this.loginBtn = this.querySelector('#login_btn');
        this.changeShippingBtn = this.querySelector('.change-shipping-type');
        this.paymentRadioBtn = this.querySelectorAll('.payment-selector');
        this.paymentBtnContainer = this.querySelector('.pay-btn');
    }

    connectedCallback()
    {
        this.handleLogin();
        this.handleChangeShippingType();
        this.handlePaymentRadioBtn();

        this.paymentRadioBtn.forEach(item => {
            if(item.checked){
                this.setPaymentForm(item.dataset.href);
            }
        });
    }

    handleLogin()
    {
        if(this.loginBtn !== null) {
            this.loginBtn.addEventListener('click',e => {
                e.preventDefault();
                HegydCore.sendRequest(e.target.dataset.href,'GET',null,data => {
                    document.querySelector('#loginFormContainer').innerHTML = data.view;
                    document.querySelector('.btn-process-ecommerce01').click();
                });

            });
        }
    }

    handleChangeShippingType()
    {
        if(this.changeShippingBtn !== null) {
            this.changeShippingBtn.addEventListener('click', e => {
                e.preventDefault();
                Api.GET($(e.target).data('href'));

            });
        }
    }

    handlePaymentRadioBtn()
    {
        this.paymentRadioBtn.forEach(item => {
            item.addEventListener('change', e => {
                this.setPaymentForm(e.target.dataset.href);
            });
        });
    }

    setPaymentForm(href)
    {
        this.paymentBtnContainer.querySelector('[type=submit]').disabled = true;
        HegydCore.sendRequest(href,'GET', null, data => {
            this.paymentBtnContainer.innerHTML = data.html;
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/front/components/CartPage.js